import * as React from "react";
import EYLogo from "./common/ey-logo";
import styled from "styled-components";
import MotifTextLink from "@ey/motif-react-wrapper/TextLink";
import { Environment } from "../util";
import { MotifIcon } from "@ey-xd/motif-react";
import { IconoirHelpCircle } from "@ey-xd/motif-icon";
import { NavLink } from "react-router-dom";

export interface EYLogoAndHelpUrlProps {
  engagementId?: string;
  uri?: string;
}

const EYLogoAndHelpUrl: React.FC<EYLogoAndHelpUrlProps> = ({ engagementId, uri }) => {
  const dryDockEnabled = Environment.isDrydockEnabled();

  return (
    <StyledHeaderSection>
      <section className="logo-wrap">
        <EYLogo logoType="" />
        <MotifTextLink href={Environment.getHelpUrl()} target="_blank">
          <MotifIcon className="help-icon-wrap" src={IconoirHelpCircle} size="24" />
        </MotifTextLink>
      </section>
      <section className="dry-dock-link">
        {dryDockEnabled && engagementId && (
          <NavLink to={{ pathname: `/drydock`, search: `?engagementId=${engagementId}` }} state={uri}>
            Dry Dock
          </NavLink>
        )}
      </section>
    </StyledHeaderSection>
  );
};

export default EYLogoAndHelpUrl;

const StyledHeaderSection = styled.section`
  margin: 0 0 var(--px-12) 0;
  display: flex;
  flex-direction: column;

  h1 {
    padding: 0;
    font-size: var(--px-24);
    margin: var(--px-11) 0 0 var(--px-13);
    display: inline-block;
  }

  .logo-wrap {
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    line-height: normal;
    margin-bottom: var(--spacing-medium);

    .motif-text-link {
      &:hover {
        border: none;
      }
    }

    .logo-wrap {
      margin-bottom: 0;
    }

    .help-icon-wrap {
      width: var(--px-16);
      height: var(--px-16);
      color: var(--neutrals-900);
      svg {
        width: 100%;
        height: 100%;
        margin-top: 0;
        path {
          fill: var(--neutrals-900);
        }
      }
    }
  }

  .dry-dock-link {
    display: flex;
    a {
      width: 100%;
    }
  }

  a {
    width: var(--px-16);
    height: var(--px-16);
  }
`;
